export default __webpack_public_path__ + "static/media/c12.199efd4c.png";